package com.essntl.features.invoice.ui.addeditinvoice.components.content

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.AnnotatedString
import com.essntl.core.utils.utils.formatIntMoney
import com.essntl.features.paymentlink.domain.model.PaymentLinkModel
import com.essntl.features.proposal.domain.utils.calculateIntMerchantFee
import com.essntl.toastmanager.ToastManager
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.dropdown.EsDropdownMenuItem
import com.essntl.uikit.components.iconbutton.destructive.EsSmallDestructiveIconButton
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.tooltip.EsTooltip
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esTypography
import kotlinx.coroutines.launch
import org.koin.compose.koinInject

@Composable
fun PaymentLinkCard(
    paymentLinkModel: PaymentLinkModel,
    isAddPaymentLinkLoading: Boolean,
    isDeactivatePaymentLinkLoading: Boolean,
    deactivatePaymentLink: (active: Boolean) -> Unit,
) {
    val toastManager = koinInject<ToastManager>()
    val scope = rememberCoroutineScope()
    val clipboardManager = LocalClipboardManager.current
    val uriHandler = LocalUriHandler.current

    var isDropDownExpanded by remember { mutableStateOf(false) }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = 1.spacing),
    ) {
        Column(
            modifier = Modifier.weight(2f),
        ) {
            Text(
                paymentLinkModel.productName ?: "",
                style = MaterialTheme.esTypography.p1Medium16,
                modifier = Modifier
                    .graphicsLayer {
                        alpha = if (paymentLinkModel.active == false) 0.5f else 1f
                    },
            )

            if (paymentLinkModel.hasMerchantFee == true)
                Text(
                    text = "merchant fee 3.5%",
                    style = MaterialTheme.esTypography.p2Regular14,
                    color = Color(0xFF016D8F),
                    modifier = Modifier
                        .alpha(if (paymentLinkModel.active == false) 0.5f else 1f),
                )
        }

        Column(
            modifier = Modifier.weight(1f),
        ) {
            Text(
                text = "$${formatIntMoney(paymentLinkModel.amount ?: 0)}",
                style = MaterialTheme.esTypography.p1Medium16,
                modifier = Modifier
                    .graphicsLayer {
                        alpha = if (paymentLinkModel.active == false) 0.5f else 1f
                    },
            )

            if (paymentLinkModel.hasMerchantFee == true) {
                val feeAmount = calculateIntMerchantFee(paymentLinkModel.amount ?: 0)

                Text(
                    text = "$${formatIntMoney(feeAmount)}",
                    style = MaterialTheme.esTypography.p2Regular14,
                    color = Color(0xFF016D8F),
                )
            }
        }

        Row(
            horizontalArrangement = Arrangement.spacedBy(1.spacing),
            modifier = Modifier,
        ) {
            EsTooltip(
                text = "View payment link",
            ) {
                EsSmallOutlineIconButton(
                    onClick = {
                        if (!paymentLinkModel.linkUrl.isNullOrEmpty())
                            uriHandler.openUri(
                                uri = paymentLinkModel.linkUrl.orEmpty(),
                            )
                    },
                    iconRes = EsIcons.Eye,
                    enabled = true,
                )
            }

            EsTooltip(
                text = "Copy to clipboard",
            ) {
                EsSmallOutlineIconButton(
                    onClick = {
                        scope.launch {
                            clipboardManager.setText(AnnotatedString(paymentLinkModel.linkUrl.orEmpty()))
                            toastManager.success(
                                title = "Payment",
                                description = "Payment link copied to clipboard",
                            )
                        }
                    },
                    iconRes = EsIcons.Copy,
                    enabled = true,
                )
            }

            Box {
                EsSmallDestructiveIconButton(
                    iconRes = EsIcons.MoreVertical,
                    onClick = {
                        isDropDownExpanded = true
                    },
                    loading = isDeactivatePaymentLinkLoading,
                    enabled = !isAddPaymentLinkLoading,
                )

                EsDropDownMenu(
                    expanded = isDropDownExpanded,
                    onDismissRequest = {
                        isDropDownExpanded = false
                    },
                ) {
                    EsDropdownMenuItem(
                        text = if (paymentLinkModel.active == true) "Deactivate" else "Activate",
                        onClick = {
                            isDropDownExpanded = false
                            deactivatePaymentLink(paymentLinkModel.active != true)
                        },
                        enabled = !isAddPaymentLinkLoading,
                    )
                }
            }
        }
    }
}